import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { CustomerStatus } from '../../model';

@Directive({
  selector: '[appCustomerStatusNameConvertion]'
})
export class CustomerStatusNameConvertionDirective implements OnInit {
  @Input() status: any;

  constructor(
    private el: ElementRef
  ) { }

  ngOnInit() {
    const element: HTMLElement = this.el.nativeElement;
    element.innerText = this.getCustomerStatusName();
  }

  getCustomerStatusName(): string {
    if (this.status === CustomerStatus.active) {
      return 'Active';
    } else if (this.status === CustomerStatus.deactivated) {
      return 'Deactivated';
    } else {
      return 'Unknown';
    }
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/customer-status2statusname/customer-status2statusname.directive.ts